export default function ServiceCategories() {
  const categories = [
    {
      title: 'Exteriors',
      image: 'https://public.readdy.ai/ai/img_res/f92326e9b1dc6e0910e03e3cd2d67631.jpg',
      capabilities: [
        'Multifamily and commercial exterior renovations',
        'Paint',
        'Roofing and Siding',
        'Window and Door Replacement',
        'Exterior amenity areas',
        'Railings'
      ]
    },
    {
      title: 'Interiors',
      image: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20apartment%20building%20lobby%20interior%20with%20contemporary%20design%20featuring%20polished%20floors%2C%20elegant%20lighting%20fixtures%2C%20comfortable%20seating%20areas%2C%20and%20stylish%20corridor%20entrance.%20Professional%20architectural%20photography%20showing%20high-end%20finishes%2C%20neutral%20color%20palette%20with%20warm%20accents%2C%20clean%20lines%2C%20and%20welcoming%20atmosphere.%20Bright%20natural%20lighting%20highlighting%20quality%20renovation%20work%20and%20attention%20to%20detail%20in%20multifamily%20residential%20space.&width=800&height=600&seq=interiors-lobby-renovation&orientation=landscape',
      capabilities: [
        'Multifamily and commercial interior renovations',
        'Lobby and Corridor Renovations',
        'Tenant Improvements'
      ]
    },
    {
      title: 'Storefront',
      image: 'https://readdy.ai/api/search-image?query=Professional%20commercial%20building%20storefront%20entrance%20featuring%20modern%20aluminum%20framed%20glass%20doors%20and%20windows%20with%20clean%20lines%20and%20contemporary%20design.%20Bright%20daylight%20photography%20showing%20high-quality%20installation%20of%20commercial%20glazing%20system%20with%20polished%20metal%20frames%20and%20clear%20glass%20panels.%20Professional%20construction%20work%20highlighting%20precision%20and%20craftsmanship%20in%20commercial%20entrance%20systems.%20Neutral%20building%20exterior%20with%20emphasis%20on%20storefront%20quality%20and%20detail.&width=800&height=600&seq=storefront-aluminum-entrance&orientation=landscape',
      capabilities: [
        'Storefront, Aluminum Framed Entrances',
        'Curtainwall'
      ]
    },
    {
      title: 'Government Contracting',
      image: 'https://readdy.ai/api/search-image?query=Professional%20government%20office%20building%20interior%20showing%20modern%20commercial%20space%20with%20clean%20finishes%2C%20professional%20lighting%2C%20polished%20floors%2C%20and%20contemporary%20design%20elements.%20Bright%20well-lit%20corridor%20or%20office%20area%20with%20neutral%20color%20scheme%2C%20quality%20construction%20finishes%2C%20and%20institutional-grade%20materials.%20Professional%20architectural%20photography%20highlighting%20attention%20to%20detail%20and%20compliance%20with%20government%20building%20standards.%20Clean%20professional%20atmosphere%20with%20modern%20amenities.&width=800&height=600&seq=government-interior-fitout&orientation=landscape',
      capabilities: [
        'Interior fit-outs',
        'Storefront',
        'Finishes',
        'Containment'
      ]
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12">
          {categories.map((category, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="h-80">
                <img
                  src={category.image}
                  alt={category.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8">
                <h3 className="text-3xl font-bold text-[#C5A55A] mb-6">
                  {category.title}
                </h3>
                <ul className="space-y-3">
                  {category.capabilities.map((capability, capIndex) => (
                    <li key={capIndex} className="flex items-start">
                      <div className="w-2 h-2 bg-[#C5A55A] rounded-full mt-2 mr-4 flex-shrink-0"></div>
                      <span className="text-lg text-gray-800">{capability}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}